import React, {useEffect, useState} from 'react';
import {Dropdown} from "primereact/dropdown";
import {elevatorFormat} from "./Formatters";


const ElevatorCompanyCell = React.memo(({
                                            node,
                                            onEditInputChange, editingRowKey,
                                            dropDownOptions
                                        }) => {

    const [value, setValue] = useState({elevatorCompanyId: '', auditElevatorCompany: ''});

    let isBuildingLine = !!node.children;
    
    useEffect(() => {
        if (editingRowKey === node.key && node.data.elevatorCompanyId)
            setValue({elevatorCompanyId: node.data.elevatorCompanyId});

    }, [editingRowKey])


    const updateRowField = (value) => {
        let option = dropDownOptions.find(x => x.value === value);
        onEditInputChange({
            elevatorCompanyId: value,
            auditElevatorCompany: option.label,
        });
        setValue({elevatorCompanyId: value});
    }

    if (editingRowKey === node.key) {

        if (dropDownOptions?.length > 0)
            return (
                <Dropdown
                    value={value.elevatorCompanyId}
                    options={dropDownOptions}
                    onChange={(e) => updateRowField(e.value)}
                    placeholder="Select a company"
                    className="w-full md:w-10rem"
                    checkmark={true}
                    highlightOnSelect={false}
                    virtualScrollerOptions={{ itemSize: 36 }}
                    scrollHeight="300px"
                    filter
                    filterBy="label"
                    filterPlaceholder="Search..."
                    resetFilterOnHide
                    showClear
                />
            )
    }

    return elevatorFormat(node.data, isBuildingLine);
});


export default ElevatorCompanyCell;

